class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    // var fetured_id = this.currentVariant.featured_media.id;
    // if(document.querySelector('.media-thumb')){
    //   document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
    //     var mediaid = e.dataset.id;
    //     if(mediaid==fetured_id){
    //       new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
    //     }
    //   });
    // }
  }
  updateURL() {
    if(__st.p.includes('product')){
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.remove('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.add('hide-selectore-button');
      });
      if(this.closest('.snippet-quick-buy-popup')) this.closest('.snippet-quick-buy-popup').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.remove('hide-selectore-button');
      });
      if(this.closest('.snippet-quick-buy-popup')) this.closest('.snippet-quick-buy-popup').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.add('hide-selectore-button');
      });
      // this.closest('.product-data').querySelector('.choose-cart').classList.remove('hide-selectore-button');
      // this.closest('.product-data').querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.add('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
      if(this.closest('.snippet-quick-buy-popup')) this.closest('.snippet-quick-buy-popup').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.add('hide-selectore-button');
      });
      if(this.closest('.snippet-quick-buy-popup')) this.closest('.snippet-quick-buy-popup').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
      // this.closest('.product-data').querySelector('.choose-cart').classList.add('hide-selectore-button');
      // this.closest('.product-data').querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    if (!productForm) return;
    productForm.forEach((form) => {
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector('[name="add"] .p-add-cart-btn span');
      // var show = document.querySelector(".choose-cart");
      // if(this.currentVariant != undefined){
      //  if (!this.currentVariant.available) {
      //       show.classList.add('variant_unavailable');
      //   } else {
      //       show.classList.remove('variant_unavailable');
      //   } 
      // }
      if(this.currentVariant != undefined){
        if(this.currentVariant.available){
          form.querySelector(".choose-cart").classList.remove('variant_sold-out');
        }else{
          form.querySelector(".choose-cart").classList.add('variant_sold-out'); 
        }
      }
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (!modifyClass) return;
      
    })
    // const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    // console.log(productForm,'togglebutton',this.dataset.section);
    // if (!productForm) return;
    // const addButton = productForm.querySelector('[name="add"]');
    // const addButtonText = productForm.querySelector('[name="add"] .p-add-cart-btn span');
    // if (!addButton) return;
    // if (disable) {
    //   addButton.setAttribute('disabled', 'disabled');
    //   if (text) addButtonText.textContent = text;
    // } else {
    //   addButton.removeAttribute('disabled');
    //   addButtonText.textContent = window.variantStrings.addToCart;
    // }
    // if (!modifyClass) return;
    // var show = this.closest('.product-data').querySelector(".choose-cart");
    // if(this.currentVariant != undefined){
    //   if(this.currentVariant.available){
    //     show.classList.remove('variant_sold-out');
    //   }else{
    //     show.classList.add('variant_sold-out'); 
    //   }
    // }
  }
  setUnavailable(){
    const button = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    button.forEach((btn) => {
      const addButton = btn.querySelector('[name="add"]');
      const addButtonText = btn.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
    })
    // const button = document.getElementById(`product-form-${this.dataset.section}`);
    // console.log(button,'unavailable',this.dataset.section);
    // const addButton = button.querySelector('[name="add"]');
    // const addButtonText = button.querySelector('[name="add"] > span');
    // const price = document.getElementById(`price-${this.dataset.section}`);
    // if (!addButton) return;
    // addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);